import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, MessageCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { LEVEL_META } from "@/lib/format";
import api from "@/lib/api";

export default function Profile() {
  const { user, logout } = useAuth();
  const { openWhatsapp } = useSettings();
  const nav = useNavigate();
  const [dash, setDash] = useState(null);
  useEffect(() => { api.get("/me/dashboard").then(({ data }) => setDash(data)).catch(() => {}); }, []);

  const meta = LEVEL_META[dash?.level_key] || LEVEL_META.pawn;

  return (
    <div className="p-5 sm:p-8 max-w-2xl mx-auto">
      <h1 className="font-heading text-3xl text-chessup-text mb-6">Perfil</h1>
      <div className="rounded-2xl border border-chessup-border bg-chessup-card p-6">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-chessup-turq/15 border border-chessup-turq/40 flex items-center justify-center text-2xl font-heading text-chessup-turq">
            {(user?.name || "?").charAt(0).toUpperCase()}
          </div>
          <div>
            <div className="font-heading text-xl text-chessup-text">{user?.name}</div>
            <div className="text-sm text-chessup-subtext">{user?.email}</div>
            <div className="text-sm text-chessup-goldlight mt-1">{meta.piece} Nível {meta.name} · {dash?.total_xp || 0} XP</div>
          </div>
        </div>
        {user?.onboarding && (
          <div className="mt-6 grid sm:grid-cols-3 gap-3 text-sm">
            <div className="rounded-lg bg-chessup-deep/40 p-3"><div className="text-xs text-chessup-subtext">Nível informado</div><div className="text-chessup-text mt-0.5">{user.onboarding.level}</div></div>
            <div className="rounded-lg bg-chessup-deep/40 p-3"><div className="text-xs text-chessup-subtext">Objetivo</div><div className="text-chessup-text mt-0.5">{user.onboarding.goal}</div></div>
            <div className="rounded-lg bg-chessup-deep/40 p-3"><div className="text-xs text-chessup-subtext">Tempo de estudo</div><div className="text-chessup-text mt-0.5">{user.onboarding.study_time}</div></div>
          </div>
        )}
        <div className="mt-6 flex flex-wrap gap-3">
          <button onClick={() => openWhatsapp("student_support")} className="inline-flex items-center gap-2 rounded-full border border-chessup-border px-5 py-2.5 text-sm text-chessup-text hover:border-chessup-turq"><MessageCircle className="h-4 w-4" /> Suporte pelo WhatsApp</button>
          <button onClick={() => { logout(); nav("/"); }} data-testid="profile-logout" className="inline-flex items-center gap-2 rounded-full border border-chessup-border px-5 py-2.5 text-sm text-chessup-text hover:border-chessup-turq"><LogOut className="h-4 w-4" /> Sair</button>
        </div>
      </div>
    </div>
  );
}
